export default "__VITE_ASSET__60416712__"